import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { ShowProgress } from "../../state/ShowProgress";
import { toast } from "react-toastify";
import { validateFields } from "../../common/helper";
import * as yup from "yup";
import { JsonRpc } from "upcx-js";

type Props = {
  item: any;
  contractName: string;
};

export const ReadContractItem = ({ item, contractName }: Props) => {
  const theme = useTheme();

  const [, setShowProgresss] = useRecoilState(ShowProgress);

  const [scope, setScope] = useState<string>("");
  const [upperBound, setUpperBound] = useState<string>("");
  const [lowerBound, setLowerBound] = useState<string>("");
  const [indexPosition, setIndexPosition] = useState<string>("");
  const [keyType, setKeyType] = useState<string>("");

  const [result, setResult] = useState<string>("");

  const validate = async () => {
    try {
      await validateFields(
        yup.object().shape({
          scope: yup.string().required("Please input scope."),
        }),
        ["scope"],
        [scope]
      );
      return true;
    } catch (err: any) {
      toast.warn(err.message);
      return false;
    }
  };

  const handleQuery = async () => {
    if (!(await validate())) {
      return;
    }

    setShowProgresss(true);

    const rpc = new JsonRpc(process.env.REACT_APP_UPCX_JSON_RPC!);

    try {
      const result = await rpc.get_table_rows({
        json: true,
        code: contractName,
        scope: scope,
        table: item.name,
        upper_bound: upperBound,
        lower_bound: lowerBound,
        index_position: indexPosition,
        key_type: keyType,
      });

      setResult(JSON.stringify(result.rows));
    } catch (err) {
      toast.error("Getting response has been failed.");
      setResult("");
    }

    setShowProgresss(false);
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{
          "*.Mui-expanded": {
            margin: "10px 0px !important",
          },
          "&.Mui-expanded": {
            minHeight: "30px",
          },
        }}
      >
        {item.name}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <div className="p-0">
          <div className="form-group">
            <div className="form-group">
              <label className="mb-2">Scope</label>
              <input
                type="text"
                className="form-control form-control-xs mb-2"
                name="input_3"
                id="input_3_1"
                data-bs-grp="g3"
                data-bs-type="uint256"
                placeholder="Scope"
                value={scope}
                onChange={(e) => setScope(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="mb-2">Upper Bound</label>
              <input
                type="text"
                className="form-control form-control-xs mb-2"
                name="input_3"
                id="input_3_1"
                data-bs-grp="g3"
                data-bs-type="uint256"
                placeholder="Upper Bound"
                value={upperBound}
                onChange={(e) => setUpperBound(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="mb-2">Lower Bound</label>
              <input
                type="text"
                className="form-control form-control-xs mb-2"
                name="input_3"
                id="input_3_1"
                data-bs-grp="g3"
                data-bs-type="uint256"
                placeholder="Lower Value"
                value={lowerBound}
                onChange={(e) => setLowerBound(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="mb-2">Index Position</label>
              <input
                type="text"
                className="form-control form-control-xs mb-2"
                name="input_3"
                id="input_3_1"
                data-bs-grp="g3"
                data-bs-type="uint256"
                placeholder="Index Position"
                value={indexPosition}
                onChange={(e) => setIndexPosition(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="mb-2">Key Type</label>
              <input
                type="text"
                className="form-control form-control-xs mb-2"
                name="input_3"
                id="input_3_1"
                data-bs-grp="g3"
                data-bs-type="uint256"
                placeholder="Key Type"
                value={keyType}
                onChange={(e) => setKeyType(e.target.value)}
              />
            </div>
            <button
              type="button"
              id="btn_3"
              className="btn btn-light border"
              onClick={handleQuery}
            >
              Query
            </button>
          </div>
          <div className="text-secondary mt-3">
            <SubdirectoryArrowRightIcon
              className="far fa-code text-secondary me-1"
              sx={{
                width: "18px",
                height: "18px",
                margin: "-5px 5px auto 0px",
              }}
            />
            <span className="text-monospace text-muted">Result</span>
            <br />
            <span id="myanswer_3">{result}</span>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
